// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"cbe19367","18":"91828ec0","114":"b23c8dd0","262":"a537a757","306":"9d79594e","447":"8442840c","591":"d530ea3b","783":"b43ab3c2","981":"37bf23a9"}[chunkId] + ".chunk.js";
};